// components/Timesheet/TimesheetDashboard.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent, Typography, Grid, Button, Box } from '@mui/material';
import { AccessTime, List, People } from '@mui/icons-material';

const TimesheetDashboard: React.FC = () => {
  const { user } = useAuth();
  const isAdmin = user?.attributes?.['custom:group'] === 'Admin';

  return (
    <div className="p-6">
      <Typography variant="h4" gutterBottom>
        Timesheet Management
      </Typography>
      
      <Grid container spacing={3} className="mt-4">
        {/* My Timesheet Card */}
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent className="text-center">
              <AccessTime className="text-4xl text-primary-green mb-4" />
              <Typography variant="h6" gutterBottom>
                My Timesheet
              </Typography>
              <Typography variant="body2" color="textSecondary" className="mb-4">
                View and manage your current timesheet
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/dashboard/timesheets/my-timesheet"
              >
                View Timesheet
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Add Time Entry Card */}
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent className="text-center">
              <List className="text-4xl text-green-600 mb-4" />
              <Typography variant="h6" gutterBottom>
                Add Time Entry
              </Typography>
              <Typography variant="body2" color="textSecondary" className="mb-4">
                Log your work hours for the week
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/dashboard/timesheets/entry"
              >
                Add Entry
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Employee Timesheets (Admin Only) */}
        {isAdmin && (
          <Grid item xs={12} md={6} lg={4}>
            <Card>
              <CardContent className="text-center">
                <People className="text-4xl text-purple-600 mb-4" />
                <Typography variant="h6" gutterBottom>
                  Employee Timesheets
                </Typography>
                <Typography variant="body2" color="textSecondary" className="mb-4">
                  Review and approve employee timesheets
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to="/dashboard/timesheets/employee-timesheets"
                >
                  Manage Timesheets
                </Button>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>

      {/* Quick Stats */}
      <Box className="mt-8">
        <Typography variant="h5" gutterBottom>
          Quick Stats
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  This Week's Hours
                </Typography>
                <Typography variant="h4">
                  {/* This would come from your timesheet context */}
                  32.5
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Submitted Timesheets
                </Typography>
                <Typography variant="h4">
                  {/* This would come from your timesheet context */}
                  1
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Pending Approval
                </Typography>
                <Typography variant="h4">
                  {/* This would come from your timesheet context */}
                  0
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default TimesheetDashboard;